import React from "react";
import { Link } from "react-router-dom";
import { OrderStatus } from "../constants";
import { premiumPaths } from "../navigation";

export function getOrderStep(status) {
  return [
    OrderStatus.APPROVED,
    OrderStatus.ISSUING,
    OrderStatus.ISSUED,
    OrderStatus.ISSUE_FAILED,
  ].includes(status)
    ? 4
    : 2;
}

export function orderStepPaths(
  order,
  {
    dirty = false,
    previewReady = order?.previewRevision === order?.revision,
  } = {},
) {
  if (!order) return {};
  const reviewing = order.status === OrderStatus.REVIEW;
  return {
    1: premiumPaths.orderDocuments(order.id),
    2: getOrderStep(order.status) === 2 ? premiumPaths.order(order.id) : null,
    3: reviewing ? premiumPaths.preview(order.id) : null,
    4:
      getOrderStep(order.status) === 4 || (reviewing && !dirty && previewReady)
        ? premiumPaths.issue(order.id)
        : null,
  };
}

export default function OrderSteps({
  step,
  paths = {},
  onNavigate,
  busy = false,
}) {
  const labels = [
    "Dodaj dokumenty",
    "Sprawdź dane",
    "Podgląd świadectwa",
    "Wystaw i pobierz",
  ];
  const current = Math.min(step, labels.length);
  return (
    <ol className="premium-steps" aria-label="Etapy świadectwa">
      {labels.map((label, index) => (
        <li
          key={label}
          className={
            index + 1 === current
              ? "active"
              : index + 1 < current
                ? "complete"
                : ""
          }
          aria-current={index + 1 === current ? "step" : undefined}
        >
          {paths[index + 1] && index + 1 !== current && !busy ? (
            <Link
              to={paths[index + 1]}
              onClick={(event) => {
                if (
                  onNavigate &&
                  event.button === 0 &&
                  !event.metaKey &&
                  !event.ctrlKey &&
                  !event.shiftKey &&
                  !event.altKey
                ) {
                  event.preventDefault();
                  onNavigate(index + 1, paths[index + 1]);
                }
              }}
            >
              <span className="premium-step-number">{index + 1}</span>
              <span>{label}</span>
            </Link>
          ) : (
            <span
              className="premium-step-label"
              aria-disabled={index + 1 !== current ? true : undefined}
            >
              <span className="premium-step-number">{index + 1}</span>
              <span>{label}</span>
            </span>
          )}
        </li>
      ))}
    </ol>
  );
}
